import React from 'react';
// import Auth from '../../../config/auth';
import Grid from '@material-ui/core/Grid';
import {styles} from './BrowserMessageScreenStyle'
import { Typography } from '@material-ui/core';

import { 
    Result,
    Button,
} from 'antd';


export default function BrowserMessageScreen(props) {
	const onclick=()=>{
            props.history.push({
                pathname: `/`,
                state: 'MI DATA de Login'
            })
    }
	return (
        <div>
            <Grid
               container
                direction="row"
                justify="center"
                alignItems="center"
                style={styles.divStyle}
                >
                    <Grid item md={12} style={styles.divSize}>
                        <Grid container item xs={12} spacing={0} style={styles.iconStyle}>
                            <img
                                alt="example"
                                src={require("../../assets/COTEMAR - HSEQ - COTEPLAY - LOGO V3-11.png")}
                                style={{ width: '30%'}}
                            />
                        </Grid>
                        <Grid container item xs={12} spacing={2} style={styles.iconStyle}>
                            <Typography color='textSecondary' align='center' variant='h2'>¡Navegador no compatible!</Typography>
                        </Grid>
                    </Grid>
            </Grid>
            <Grid
               container
                direction="row"
                justify="center"
                alignItems="center"
                style={styles.bStyle}
                >
                <Grid item md={12} >
                    <Typography color='textSecondary' align='center' variant='h5'>Te recomendamos utilizar las versiones más actuales de los siguientes navegadores:</Typography>
                </Grid>
                    <Grid item md={4} spacing={0} >
                        <div style={{display: 'flex', justifyContent:'center', flexDirection:'column'}}>
                            <img
                                alt="cromo"
                                src={require("../../../assets/cromo.png")}
                                style={{ width: '15vh', height: '15vh', alignSelf:'center'}}
                            />
                            <label>v78.0.3904.108</label>
                        </div>
                    </Grid>
                    <Grid item md={4} spacing={0} >
                        <div style={{display: 'flex', justifyContent:'center', flexDirection:'column'}}>
                            <img
                                alt="mozzila"
                                src={require("../../../assets/mozilla.png")}
                                style={{ width: '15vh', height: '15vh', alignSelf:'center'}}
                            />
                            <label>v70</label>
                        </div>
                    </Grid>
                    <Grid item md={4} spacing={0} >
                        <div style={{display: 'flex', justifyContent:'center', flexDirection:'column'}}>
                            <img
                                alt="safari"
                                src={require("../../../assets/safari.png")}
                                style={{ width: '15vh', height: '15vh', alignSelf:'center'}}
                            />
                            <label>v13.0</label>
                        </div>
                    </Grid>
                </Grid>
        </div>
    )
}